export const VANILLA = "GPT";
export const EXCEL = "Excel";
export const PDF = "DOCS GPT";
export const NEO4J = "Neo4j";
export const DATABASE = "Database";
export const IMAGE = "Image";
export const PENDING = "pending";
export const APPROVED = "approved";
export const USER = "user";
export const ADMIN = "admin";
export const YOUTUBE = "Youtube";
export const COLLECTION = "Collections";
export const PROMPT = "Prompt";
export const DEFAULT_LLM_MODEL = "gpt-4o";
export const FALLBACK_LLM_MODEL = "gpt-4o";
export const WEB = "Web";
// export const DEFAULT_IMAGE_MODEL = "dall-e-3";
// export const IMAGE_GENERATOR = "Image Generator";
